import {createAsyncThunk} from '@reduxjs/toolkit';
import {getUser} from 'api/auth/auth';
import type {OperatorUserResponse} from 'api/auth/auth.types';

export const USER_LOGOUT = 'USER_LOGOUT';

/**
 * Gets the currently authenticated user and updates the store with the user data
 *
 */
export const getUserData = createAsyncThunk<
    OperatorUserResponse,
    void,
    {rejectValue: Error}
>('user/getUserData', async (_, {rejectWithValue}) => {
    try {
        const response = await getUser();

        return response.data;
    } catch (error) {
        return rejectWithValue(error as Error);
    }
});
